// Reserve.js
import PropTypes from "prop-types"
import React from "react"
import { Col, Container, Row, Card, CardBody, Table } from "reactstrap"
import { withTranslation } from "react-i18next"
import WaveChart from "pages/Dashboard/WaveChart"
import Chart from "react-apexcharts"

// Small stat card
const StatCard = ({ title, value }) => (
  <Col md={3} className="mb-4">
    <Card className="border shadow-none text-center">
      <CardBody>
        <h4 className="mb-2">{value}</h4>
        <p className="mb-0 text-muted">{title}</p>
      </CardBody>
    </Card>
  </Col>
)

const Reserve = props => {
  document.title = "Reserve | CurbDash"

  // Mock data
  const stats = [
    { title: "Total Revenue", value: "$156" },
    { title: "Total Members", value: "223" },
    { title: "Free Memberships", value: "181" },
    { title: "Paid Memberships", value: "36" }
  ]

  const reserveData = {
    title: "Reserve Use",
    series: [5, 10, 15, 5, 8, 18, 12],
    categories: ["7/1", "7/8", "7/15", "7/22", "7/29", "8/5"]
  }

  const membersData = {
    options: {
      chart: { type: "bar", toolbar: { show: false } },
      xaxis: {
        categories: ["7/12", "7/15", "7/16", "7/17", "7/18"]
      },
      dataLabels: { enabled: false },
      grid: { borderColor: "#f1f1f1" }
    },
    series: [{ name: "Members", data: [0, 1, 2, 1, 3] }]
  }

  const topLots = [
    { name: "Modo Yoga LA", visits: 23 },
    { name: "Spring Place Beverly Hill", visits: 14 },
    { name: "Republique", visits: 8 }
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Stat cards */}
          <Row>
            {stats.map((s, idx) => (
              <StatCard key={idx} title={s.title} value={s.value} />
            ))}
          </Row>

          {/* Charts */}
          <Row className="mb-4">
            <Col md={6}>
              <WaveChart
                title={reserveData.title}
                series={reserveData.series}
                labels={reserveData.categories}
              />
            </Col>
            <Col md={6}>
              <Card className="border shadow-none">
                <CardBody>
                  <h6 className="mb-3">Members</h6>
                  <Chart
                    options={membersData.options}
                    series={membersData.series}
                    type="bar"
                    height={250}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Top Lots */}
          <Row>
            <Col xl={12}>
              <Card className="border shadow-none">
                <CardBody>
                  <h5 className="mb-3">Top Lots</h5>
                  <Table className="align-middle table-nowrap mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Lot Name</th>
                        <th>Visits</th>
                      </tr>
                    </thead>
                    <tbody>
                      {topLots.map((lot, idx) => (
                        <tr key={idx}>
                          <td>{lot.name}</td>
                          <td>{lot.visits}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Reserve.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func
}

export default withTranslation()(Reserve)